/**
 * Cda related apis
 */

import { 
  getRequestConfig, 
  getFileUploadRequestConfig,
  getFileDownloadRequestConfig
} from './config';
import { 
  CDA_UPLOAD_ACTION, 
  SCAN_CDA_ACTION,
  REQUEST_CDA_ACTION, 
  SAVE_CDA_ACTION,
  DOWNLOAD_CDA_ACTION,
  DELETE_CDA_ACTION,
  CDA_MEDICATION_IMPORT_ACTION
} from './ajaxActions';
import { 
  GET_CDA_DOC_SUCCESS_MESSAGE, 
  UPLOAD_CDA_SUCCESS_MESSAGE, 
  SAVE_CDA_SUCCESS_MESSAGE,
  CDA_EXISTS_MESSAGE,
  INVALID_FILE_FORMAT_MESSAGE
} from './ajaxActionResponse';
import { request } from './request';
import { isMfaRequiredBlob, redirectToCodePage } from '@/api/mfaRequired';
import store from '@/store';

/** More explicit error message for CDA upload parse errors. */
export const INVALID_CDA_UPLOAD_PARSE_MESSAGE =
  'The contents of this file are not a valid CDA and thus cannot be parsed. Try exporting a new CDA (.xml) from your health record system and try again.';

/**
 * Uploads cda to database
 * upload success reponse from server: {'message' : 'cdaUploadedMessage', 'id' : $idCda}
 * @param {object} formData multipart form data, contains cda in xml format
 * @returns promise
 */
/*export function uploadCda (formData) {
  const config = getFileUploadRequestConfig(formData, CDA_UPLOAD_ACTION);
  try {
    return new Promise((resolve, reject) => {
      request(config)
      .then( (response) => {
        console.log("Before Error is thrown");
        console.log(response);
        if (response && response.data.message === UPLOAD_CDA_SUCCESS_MESSAGE) {
          resolve(response);
        } else if (response && response.data.message === CDA_EXISTS_MESSAGE) {
          reject('CDA is already uploaded.');
        } else if (response && response.data.message === INVALID_FILE_FORMAT_MESSAGE) {
          reject('Invalid CDA file format.');
        } else {
          reject(`unable to upload cda: ${(response?response.data:'no reponse from server')}`);
        }
      })
      .catch((err) => {
        // Backend sometimes returns 500 error even upload succeeds, so it's treated as success when response contains success fields, ie. message and id.
        const data = err.response?.data;
        console.log("Looking for Errors");
        console.log(data);
        if (data && typeof data === 'object') {
          if (data.message === UPLOAD_CDA_SUCCESS_MESSAGE && data.id != null) {
            if (data.csrf) {
              store.dispatch('login/updateCsrf', data.csrf);
            }
            resolve({
              data,
              status: err.response.status,
              statusText: err.response.statusText,
              headers: err.response.headers,
            });
            return;
          }
          if (data.message === CDA_EXISTS_MESSAGE) {
            reject('CDA is already uploaded.');
            return;
          }
          if (data.message === INVALID_FILE_FORMAT_MESSAGE) {
            reject('Invalid CDA file format.');
            return;
          }
        }
        reject(err);
      });
    });
  } catch (error) {
    console.log("Good Luck Everybody Else");
    console.log(error);
    console.log("Error Response");
    console.log(error.response);
  }
 
}; */ 
//Test function Newer 
export async function uploadCda(formData) {
  const config = getFileUploadRequestConfig(formData, CDA_UPLOAD_ACTION);
 
  try {
    // axios will reject for non-2xx; successful 2xx responses end up here
    const response = await request(config);
    const data = response?.data;
 console.log("IND OUT WHATS GOING ON");
 console.log(data);
    if (data?.message === UPLOAD_CDA_SUCCESS_MESSAGE) {
      // update CSRF if provided
      if (data.csrf) {
        store.dispatch('login/updateCsrf', data.csrf);
      }
      return response;
    }
 
    if (data?.message === CDA_EXISTS_MESSAGE) {
      throw new Error('CDA is already uploaded.');
    }
 
    if (data?.message === INVALID_FILE_FORMAT_MESSAGE) {
      throw new Error('Invalid CDA file format.');
    }
 
    throw new Error(`Unable to upload CDA: ${JSON.stringify(data ?? 'no response body')}`);
  } catch (err) {
    console.log("If Its AN ERROR SHOW ME THE MONEY");
    console.log(err);
    // err may be an axios error with err.response (server returned non-2xx)
     // log everything
  await logAxiosError(err, 'uploadCda failed');
 
  const res = err?.response;
  const resData = res?.data;
 
  // Special-case: server returned 500 but body indicates success
  if (resData && typeof resData === 'object' && resData.message === UPLOAD_CDA_SUCCESS_MESSAGE && resData.id != null) {
    if (resData.csrf) store.dispatch('login/updateCsrf', resData.csrf);
    return { resData, status: res.status ?? 500, statusText: res.statusText ?? 'Server Error', headers: res.headers ?? {} };
  }
 
  // Propagate a clear Error with server status/message when possible
  if (res) {
    const serverMsg = typeof resData === 'string' ? resData : resData?.message ?? JSON.stringify(resData ?? {});
    throw new Error(`Upload failed (status ${res.status}): ${serverMsg}`);
  }
 
  // network/client error
  throw err;
 
    // If it's an axios error, include status & server message where possible
    if (res) {
      const serverMsg = (typeof resData === 'string') ? resData : resData?.message ?? JSON.stringify(resData ?? {});
      throw new Error(`Upload failed (status ${res.status}): ${serverMsg}`);
    }
 
    // Network/client error or other thrown error
    throw err;
  } finally {
    // place cleanup here if needed in future
  }
}

export function scanCdaById(id) {
  const config = getRequestConfig({id: id}, SCAN_CDA_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      if (response && response.data.message === 'cdaScanedMessage') {
        resolve();
      } else {
        reject(`Failed to scan cda..`);
      }
    })
    .catch( (err) => {
      reject(err);
    });
  });

}

/**
 * Retrieves cda as a document for viewing
 * request success reponse from server: {'message' : 'replyCdaMessage', 'id' : $idCda, 'text': $cdaDoc}
 * @param {integer} id id of cda to request
 * @returns promise
 */
export function getCdaDocById(id) {
  // const config = getRequestConfig({id: id}, REQUEST_CDA_ACTION);
  const config = getRequestConfig({id: id}, REQUEST_CDA_ACTION, '/file/cdas');

  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      resolve(response.data.data.cda);
    })
    .catch( (err) => {
      reject(err);
    });
  });
};
async function logAxiosError(err, label = 'AxiosError') {
  try {
    console.error(`--- ${label} ---`);
    console.error('Error object:', err);
 
    if (err.message) console.error('Message:', err.message);
    if (err.stack) console.error('Stack:', err.stack);
 
    const res = err?.response;
    if (res) {
      console.error('Status:', res.status);
      console.error('StatusText:', res.statusText);
      console.error('Headers:', res.headers);
 
      // If response data is a Blob (responseType: 'blob') convert to text
      const data = res.data;
      if (data && typeof data.text === 'function') {
        try {
          const text = await data.text();
          console.error('Body (text from blob):', text);
        } catch (e) {
          console.error('Failed to read blob body as text:', e);
        }
      } else {
        // Non-blob body (object/string)
        console.error('Body:', data);
      }
    } else if (err.request) {
      // No response received
      console.error('No response received. Request:', err.request);
    } else {
      // Something happened in setting up the request
      console.error('Request setup error');
    }
  } catch (loggingErr) {
    // Best-effort logging failure
    console.error('Error while logging axios error:', loggingErr);
  }
}
export function requestSaveCda(id) {
  const config = getRequestConfig({id: id}, SAVE_CDA_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      if (response && response.data.message === SAVE_CDA_SUCCESS_MESSAGE) {
        resolve(response);
      } else {
        reject(`unable to save cda ${id}, response: ${JSON.stringify(response)}`);
      }
    })
    .catch( (err) => {
      reject(err);
    });
  });
}

export function downloadCdaById(id) {
  const config = getFileDownloadRequestConfig({id: id}, DOWNLOAD_CDA_ACTION);
  return request(config).catch(async (err) => {
    // This asks for a Blob, so a 401 mfa_required from pacmny-be's document
    // gate is a Blob the axios interceptor cannot read; send the user to the
    // code page here instead.
    if (await isMfaRequiredBlob(err)) redirectToCodePage();
    throw err;
  });
}

export function deleteCdaById(id) {
  const config = getRequestConfig({id:id}, DELETE_CDA_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  })
}

// Calls /online/ajax cdaMedicationImport to enrich CDA med rows before InsertMedication.
export function fetchCdaMedicationImportFields(cdaId, items) {
  const config = getRequestConfig(
    { cdaId, items },
    CDA_MEDICATION_IMPORT_ACTION
  );
  return request(config).then((response) => {
    const payload = response?.data;
    // Fail fast so the import loop can fall back to sidebar-only code resolution.
    if (!payload || String(payload.status).toUpperCase() !== 'OK') {
      throw new Error(payload?.message || 'Failed to load CDA medication import fields');
    }
    return payload.data?.fields || {};
  });
}